export default "__VITE_ASSET__MG16TNPZ__"